<template>
  <div class="search">
    <form action="/">
      <van-search v-model="value" shape="round" placeholder="搜索商品" show-action @search="onSearch" :autofocus='true' />
    </form>
    <hr />
    <div class="history" v-if="searchArr.length !== 0">
      <div class="title">
        <p class="text">历史搜索</p>
        <span class="empty" @click="onEmpty">
          <van-icon name="delete" />
        </span>
      </div>
      <ul class="tags">
        <li v-for="(item,index) in searchArr" :key="index">
          <span @click="onHistory(item)">{{item}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Search, Toast, Icon } from 'vant'
var newArr = []
export default {
  name: 'search',
  components: {
    [Search.name]: Search,
    [Icon.name]: Icon
  },
  data () {
    return {
      value: '',
      searchArr: []
    }
  },
  created () {
    console.log(newArr)
    this.searchArr = newArr
  },
  mounted() {
    // console.log(document.getElementsByTagName('input')[0])
    document.getElementsByTagName('input')[0].focus()
  },
  methods: {
    onSearch () {
      console.log(this.value)
      if (this.value.replace(/\s+/g, '') === '') {
        Toast('搜索不能为空')
      } else {
        newArr.push(this.value)
        console.log(newArr)
        this.$router.push({
          path: '/searchList',
          query: { keywords: this.value }
        })
      }
    },
    onHistory (key) {
      console.log(key)
      this.$router.push({
        path: '/searchList',
        query: { keywords: key }
      })
    },
    onEmpty () {
      this.searchArr = []
      newArr = []
    }
  }
}
</script>

<style lang="less" scoped>
@pierce: ~">>>";
@widthframe: 690px;
* {
  box-sizing: border-box;
}
.search {
  padding-top: 20px;
}
.van-search {
  width: @widthframe;
  height: 60px;
  padding: 0;
  margin: 20px auto 20px;
  @{pierce} .van-cell {
    line-height: 60px;
  }
  @{pierce} .van-icon {
    font-size: 40px;
    padding-top: 2px;
  }
  @{pierce} input {
    // height: 100%;
    // line-height: 100%;
    font-size: 29px;
    // margin-top: 8px;
    // padding-top: 10px;
  }
  @{pierce} .van-search__action{
    font-size: 29px;
  }
}
hr {
  width: 100%;
  height: 1px; /* no*/
  background: #f5f5f5;
  overflow: hidden;
  border: none;
  padding: 0;
  margin-bottom: 20px;
}
.history {
  width: @widthframe;
  margin: 0 auto;
  .title {
    width: 100%;
    overflow: hidden;
    .text {
      float: left;
      font-size: 28px;
      font-weight: bold;
      color: #666;
    }
    .empty {
      float: right;
      .van-icon {
        font-size: 32px;
        margin-top: 2px;
      }
    }
  }
  .tags {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 16px;
    li {
      border-radius: 15px;
      background-color: #f2f2f2;
      display: inline-flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-right: 24px;
      margin-bottom: 16px;
      span {
        color: #333;
        font-size: 24px;
        line-height: 42px;
        padding: 0 16px;
        display: block;
        overflow: hidden;
        word-break: break-all;
      }
    }
  }
}
/deep/ .van-search .van-cell {
    padding: 5px 8px 5px 0;
    font-size: 14px;
    line-height: 40px
}
/deep/ .van-search__content{
  line-height: 70px;
}
/deep/ .van-field__control{
  // line-height: 30px;
}
</style>
